import { render } from "./ChildDuplicatesView.vue?vue&type=template&id=0a84f13a&scoped=true&ts=true"
import script from "./ChildDuplicatesView.vue?vue&type=script&lang=ts"
export * from "./ChildDuplicatesView.vue?vue&type=script&lang=ts"

import "./ChildDuplicatesView.vue?vue&type=style&index=0&id=0a84f13a&scoped=true&lang=css"
import "./ChildDuplicatesView.vue?vue&type=style&index=1&id=0a84f13a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a84f13a"]])

export default __exports__